import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { Circle } from "lucide-react"

import { cn } from "@/lib/utils"
import { trackedValueChange } from "@/lib/usageEvents"

const RadioGroupTrackContext = React.createContext(null)

const RadioGroup = React.forwardRef(({ className, trackId, trackValue = false, onValueChange, ...props }, ref) => {
  return (
    <RadioGroupTrackContext.Provider value={trackId ?? null}>
      <RadioGroupPrimitive.Root
        className={cn("grid gap-2", className)}
        onValueChange={trackedValueChange(trackId, trackValue, onValueChange)}
        {...props}
        ref={ref} />
    </RadioGroupTrackContext.Provider>
  );
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      data-ev={React.useContext(RadioGroupTrackContext) ?? undefined}
      className={cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}>
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <Circle className="h-3.5 w-3.5 fill-primary" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
